var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.665,
    height: 19.95,
    viewBox: "0 0 34.665 19.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-wave-1508032",
    transform: "translate(-5.596 -36.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_855",
    "data-name": "Groupe 855",
    transform: "translate(5.596 36.787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_172",
    "data-name": "Trac\\xE9 172",
    d: "M39.117,40.839a7.7,7.7,0,0,1-4.28-1.574,7.078,7.078,0,0,0-3.922-1.474,7.087,7.087,0,0,0-3.923,1.474,7.692,7.692,0,0,1-4.28,1.574,7.7,7.7,0,0,1-4.28-1.574,7.08,7.08,0,0,0-3.922-1.474,7.082,7.082,0,0,0-3.922,1.474,7.7,7.7,0,0,1-4.28,1.574c-.394,0-.713-.225-.713-.5s.319-.5.713-.5a6.21,6.21,0,0,0,3.328-1.317,8.668,8.668,0,0,1,4.874-1.731,8.664,8.664,0,0,1,4.874,1.731,6.21,6.21,0,0,0,3.328,1.317,6.21,6.21,0,0,0,3.328-1.317,8.666,8.666,0,0,1,4.874-1.731,8.664,8.664,0,0,1,4.874,1.731,6.21,6.21,0,0,0,3.327,1.317C40.358,39.835,40.9,40.839,39.117,40.839Z",
    transform: "translate(-5.596 -36.787)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_856",
    "data-name": "Groupe 856",
    transform: "translate(5.596 44.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_173",
    "data-name": "Trac\\xE9 173",
    d: "M39.117,50.239a7.7,7.7,0,0,1-4.28-1.574,7.082,7.082,0,0,0-3.922-1.474,7.091,7.091,0,0,0-3.923,1.474,7.692,7.692,0,0,1-4.28,1.574,7.7,7.7,0,0,1-4.28-1.574,7.084,7.084,0,0,0-3.922-1.474,7.086,7.086,0,0,0-3.922,1.474,7.7,7.7,0,0,1-4.28,1.574c-.394,0-.713-.225-.713-.5s.319-.5.713-.5a6.21,6.21,0,0,0,3.328-1.317,8.664,8.664,0,0,1,4.874-1.731,8.66,8.66,0,0,1,4.874,1.731,6.21,6.21,0,0,0,3.328,1.317,6.21,6.21,0,0,0,3.328-1.317,8.662,8.662,0,0,1,4.874-1.731,8.66,8.66,0,0,1,4.874,1.731,6.21,6.21,0,0,0,3.327,1.317C40.358,49.235,40.9,50.239,39.117,50.239Z",
    transform: "translate(-5.596 -46.187)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_857",
    "data-name": "Groupe 857",
    transform: "translate(5.596 52.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_174",
    "data-name": "Trac\\xE9 174",
    d: "M39.117,59.64a7.7,7.7,0,0,1-4.28-1.574,7.078,7.078,0,0,0-3.922-1.474,7.09,7.09,0,0,0-3.923,1.474,7.7,7.7,0,0,1-4.28,1.574,7.7,7.7,0,0,1-4.28-1.574,7.08,7.08,0,0,0-3.922-1.474,7.086,7.086,0,0,0-3.922,1.474,7.7,7.7,0,0,1-4.28,1.574c-.394,0-.713-.225-.713-.5s.319-.5.713-.5a6.211,6.211,0,0,0,3.328-1.318,8.668,8.668,0,0,1,4.874-1.73,8.664,8.664,0,0,1,4.874,1.73,6.211,6.211,0,0,0,3.328,1.318,6.211,6.211,0,0,0,3.328-1.318,8.666,8.666,0,0,1,4.874-1.73,8.664,8.664,0,0,1,4.874,1.73,6.211,6.211,0,0,0,3.327,1.318C40.358,58.636,40.9,59.64,39.117,59.64Z",
    transform: "translate(-5.596 -55.588)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeIcon);
export default __webpack_public_path__ + "static/media/age-icon.a01b593919ebd6e24891a9cd7ea5c2c6.svg";
export { ForwardRef as ReactComponent };